import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& .MuiDialog-container': {
      margin: '32px 0px',
      '& .MuiDialog-paperScrollPaper': {
        maxHeight: 'calc(100vh - 64px)'
      },
      '& .MuiDialog-paper': {
        width: '352px'
      }
    }
  },
  dialogTitle: {
    paddingLeft: '20px',
    backgroundColor: '#F5F5F5',
    borderBottom: '1px solid #c2c2c2',
    '& .MuiTypography-h6': {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px'
    }
  },
  dialogContentWrapperTypeOnly: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 16px'
  },
  inputLabel: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
    color: colorSet.gray900,
    margin: '12px 0px'
  },
  acitonButtonBox: {
    margin: '0px !important',
    display: 'flex',
    flexDirection: 'column'
  },
  actionButton: {
    width: '100%',
    marginBottom: '8px',
    height: 42,
    padding: '6px 0px',
    '&.MuiButton-outlinedPrimary': {
      border: `1px solid ${colorSet.primary700}`,
      color: colorSet.primary700
    },
    '&.MuiButton-containedPrimary': {
      backgroundColor: colorSet.primary700
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& .MuiFormControl-root': {
      marginBottom: '8px',
      '& input': {
        '&:disabled': {
          backgroundColor: colorSet.gray100,
          color: colorSet.gray700
        }
      }
    }
  },
  isPrivateBox: {
    transform: 'translateY(-7px)',
    alignSelf: 'flex-end',
    display: 'flex',
    '& .MuiButtonBase-root': {
      padding: '11px',
      transform: 'translateY(-1px)',
      '& .MuiSvgIcon-root': {
        width: '20px',
        height: '20px'
      }
    }
  },
  checkboxLabel: {
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: colorSet.primary500
    },
    color: colorSet.gray900,
    lineHeight: '36px',
    fontSize: '14px',
    fontWeight: 400
  },
  dividerTypeOnly: {
    height: '1px',
    width: '320px',
    background: '#E5E5E5',
    alignSelf: 'center',
    margin: '24px 0px'
  },
  submitButton: {
    marginTop: '24px',
    height: 48
  },
  bizBtnLabel: {
    display: 'block',
    textAlign: 'left'
  },
  radio: {
    padding: '0px 8px 0px 0px'
  }
}));

export default useStyles;
